import { datadogRum } from '@datadog/browser-rum';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

import userAtom from '@/store/user.store';

const useDatadog = () => {
  const [user] = useAtom(userAtom);
  const location = window.location.href;

  // Initialize DataDog, if the app is in production and datadog has not yet been initialized
  const initializeDataDog = useCallback(() => {
    if (
      location.includes('scope.pondurance.com') &&
      datadogRum.getInitConfiguration() === undefined
    ) {
      datadogRum.init({
        applicationId: 'b17f39ca-6875-4445-8336-c4642e28bc15',
        clientToken: 'pubbce5227bc8f01fac0cdfe84df64a1b0b',
        site: 'datadoghq.com',
        service: 'scope2',
        env: 'prod',
        version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: (event) => {
          // Browser extensions (antivirus web-protection, translators, etc.)
          // can throw this from their own content-script RPC bridge. It's
          // unrelated to app code and occurs across unrelated routes, so
          // drop it to avoid polluting RUM error reporting.
          if (
            event.type === 'error' &&
            event.error?.message?.includes('Object Not Found Matching Id')
          ) {
            return false;
          }
          return true;
        }
      });
    }
  }, [user]);

  return initializeDataDog();
};

export default useDatadog;
